//MACD
function MACD() {
};

MACD.analysis = function(technical, data) {
	// console.log("===============MACD.analysis start ==================");
	var paramEMAShort = technical.params[0];
	var paramEMALong = technical.params[1];
	var paramSignal = technical.params[2];

	var resultEMAShort = new Array();
	var resultEMALong = new Array();
	var resultMACD = new Array();
	var resultMACDSignal = new Array();
	var resultOsc = new Array();

	technical.data = {};

	technical.data["resultEMAShort"] = resultEMAShort;
	technical.data["resultEMALong"] = resultEMALong;
	technical.data["resultMACD"] = resultMACD;
	technical.data["resultMACDSignal"] = resultMACDSignal;
	technical.data["resultOsc"] = resultOsc;

	MACD.calc(data, paramEMAShort, paramEMALong, paramSignal, resultEMAShort, resultEMALong, resultMACD, resultMACDSignal, resultOsc);
};

MACD.calc = function(data, paramEMAShort, paramEMALong, paramSignal, resultEMAShort, resultEMALong, resultMACD, resultMACDSignal, resultOsc) {
	var startIndex = Math.max(0, resultEMAShort.length - 1);
	var emaMax = Math.max(paramEMAShort, paramEMALong);
	
	var start = 0;
	for (var i = startIndex; i < data.length; i++) {
		if (data[i].close != null) {
			start = i;
			break;
		}
	}
	
	emaMax += start;

	for (var i = startIndex; i < data.length; i++) {
		MACD.calcEMA(data, i, paramEMAShort, resultEMAShort);
		MACD.calcEMA(data, i, paramEMALong, resultEMALong);

		// console.log("resultEMAShort : " + resultEMAShort + "resultEMALong : " + resultEMALong);
		if (i >= emaMax - 1) {
			var macd = resultEMAShort[i] - resultEMALong[i];
			resultMACD[i] = MACD.round(macd);
		}

		if (i >= emaMax + paramSignal - 2) {
			var total = 0;

			for (var j = 0; j < paramSignal; j++) {
				total += resultMACD[i - j];
			}

			var signal = total / paramSignal;
			resultMACDSignal[i] = MACD.round(signal);
			resultOsc[i] = MACD.round(resultMACD[i] - resultMACDSignal[i]);
		}
	}
};

MACD.calcEMA = function(data, position, param, result) {
	if (position < param - 1) {
		result[position] = null;
	} else if (position == param - 1 || result[position - 1] == null) {
		var total = 0;

		for (var i = 0; i < param; i++) {
			if (data[position - i].close != null) {
				total += data[position - i].close;
			} else {
				result[position] = null;
				return;
			}
		}

		var ema = total / param;
	} else {
		ema = result[position - 1] + (data[position].close - result[position - 1]) * 2 / (1 + param);
	}

	result[position] = MACD.round(ema);
};

MACD.round = function(v) {
	if (v != null) {
		return Math.round(v * 1000000) / 1000000;
	} else {
		return null;
	}
};

window.MACD = MACD
